import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('@dental-ui/landing').then((m) => m.HomeComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('@dental-ui/landing').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
